import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

/**
 * The API path of a bank file's model preview: a public FilePermission by
 * id, a private item by its project and id.
 * @param {{mode: 'PUBLIC'|'PRIVATE', id: string, projectId?: string}} target
 * @returns {string}
 */
export const modelPreviewApiPath = ({ mode, id, projectId }) =>
  mode === 'PRIVATE'
    ? `project-bank/private/project/${projectId}/file/${id}/model-preview`
    : `files/project-bank/${id}/model-preview`;

const post = async (apiPath, body) => {
  const signedRequest = await createSignedPostRequest({ apiPath, body });
  const response = await axios(signedRequest);
  return response.data;
};

/**
 * A signed URL to PUT a bank file's model preview PNG to.
 * @returns {Promise<{uploadUrl: string}>}
 */
export const postModelPreviewUploadUrl = (target, version) =>
  post(`${modelPreviewApiPath(target)}/upload-url`, { version });

/**
 * Tells the API the preview is uploaded; it checks the PNG and records it.
 * @returns {Promise<{modelThumbnailAt: string, modelThumbnailVersion: number}>}
 */
export const postConfirmModelPreview = (target, version) =>
  post(modelPreviewApiPath(target), { version });
